import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { InvoiceDetailsDialogProps } from '../../models/InvoiceDetailsDialogProps';
import { InvoiceData } from '../../models/Invoice';

const initialState: InvoiceDetailsState = {
    open: false,
    dialogContent: null,
};

export const invoiceDetailsDialogSlice = createSlice({
    name: 'invoiceDetailsDialog',
    initialState,
    reducers: {
        setOpen: (state, action: PayloadAction<boolean>) => {
            state.open = action.payload;
        },
        setInvoiceDetailsDialog: (
            state,
            action: PayloadAction<InvoiceData>
        ) => {
            state.dialogContent = action.payload;
        },
    },
});

export interface InvoiceDetailsState {
    open: boolean;
    dialogContent: InvoiceData | null | undefined;
}

export const invoiceDetailsDialogAction = invoiceDetailsDialogSlice.actions;

export default invoiceDetailsDialogSlice.reducer;
